import { createPatchEndpoint, HttpHeader } from '@sonar-software/sonar-http';

export type PatchUserRequest = {
	userId: number;
	email?: string;
	firstName?: string;
	lastName?: string;
	shardName?: string;
};

export const patchUser = createPatchEndpoint<PatchUserRequest, void>(
	(request) => `/api/v3/core/users/${request?.userId}`,
	{
		headers: (request) => {
			if (request?.shardName) {
				return { [ HttpHeader.Shard ]: request.shardName };
			}

			return {};
		},
		requestTransform: ({ userId, shardName, ...rest }) => rest
	}
);
